export const assets = {
  assets: {
    button: {
      update: 'UPDATE',
    },
    copyToClipboard: 'Copy File Path',
    deleteConfirmInline: 'Delete media? This cannot be undone.',
    diskFull: 'Disk Full',
    enums: {},
    fileExplorer: {
      /* keep in sync with haiui/react/src/components/FileExplorer/FileExplorer-helpers.ts */
      moveModalCurrentLocationText: 'Current Location:',
      moveModalNewLocationText: 'New Location:',
      emptyStateHeadingText: 'No Recordings',
      emptyStateSubHeadingText: 'Record a stream in order to view them.',
    },
    deleteModal: {
      title: 'Delete {{count}} recording?',
      title_plural: 'Delete {{count}} recordings?',
      titleInProgress: 'Deleting {{count}} recording',
      titleInProgress_plural: 'Deleting {{count}} recordings',
    },
    deleteLastSegmentModal: {
      title: 'Delete Segment File?',
      title_plural: 'Delete All Segment Files?',
      titleInProgress: 'Deleting {{count}} recording',
      titleInProgress_plural: 'Deleting {{count}} recordings',
      subtitle:
        'Deleting all segments will also delete its folder and return you to the Media Directory. This cannot be undone.',
    },
    import: {
      title: 'Import Media',
    },
    noLogo: 'No Media',
    notifications: {
      deleteErrorMsg_plural: '{{count}} medias could not be deleted',
      deleteErrorMsg: '{{count}} media could not be deleted',
      deleteSuccessMsg: '{{count}} media deleted',
      deleteSuccessMsg_plural: '{{count}} medias deleted',
      deleteSuccessWithErrorsMsg: '{{count}} media deleted while {{failures}} could not be deleted',
      deleteSuccessWithErrorsMsg_plural: '{{count}} medias deleted while {{failures}} could not be deleted',
      importErrorMsg: 'Failed uploading media',
      importSuccessMsg: 'Success uploading media',
      importSuccessMsg_plural: 'Success uploading {{count}} medias',
      importNetworkError: 'A network error occured. ',
      insufficientDiskSpace: 'Free up disk space in order to start a recording.',
      viewMedia: 'View Media',
    },
    sections: {
      title: 'Medias',
    },
    validations: {},
    viewSegments: 'Open',
    widget: {
      internalStorage: 'Internal Storage',
    },
  },
};
